import { HasForm, QueryMatch, UrlMatch } from "~/src/__generated__/schema";

import { FunnelImportRowValues, ImportPageValues } from "./validationSchema";

export const toImportAction = (
  value: string
): "CREATE" | "UPDATE" | "%future added value" => {
  if (value === "CREATE") return "CREATE";
  if (value === "UPDATE") return "UPDATE";
  return "%future added value";
};

export const toUrlMatch = (value: string): UrlMatch => {
  switch (value) {
    case "EQUAL_TYPE":
      return "EQUAL_TYPE";
    case "HAS_ID_TYPE":
      return "HAS_ID_TYPE";
    case "EQUAL_OR_HAS_ID_TYPE":
      return "EQUAL_OR_HAS_ID_TYPE";
    case "STARTS_WITH_PREFIX_MATCH":
      return "STARTS_WITH_PREFIX_MATCH";
    case "REGEX_MATCH_TYPE":
      return "REGEX_MATCH_TYPE";
    default:
      return "EQUAL_TYPE";
  }
};

export const toQueryMatch = (
  value: string | null | undefined
): QueryMatch | null => {
  switch (value) {
    case "EQUAL_MATCH":
      return "EQUAL_MATCH";
    case "INCLUDING_MATCH":
      return "INCLUDING_MATCH";
    case "PREFIX_MATCH":
      return "PREFIX_MATCH";
    default:
      return null;
  }
};

const emptyToNull = (value: string): string | null =>
  value.trim() === "" ? null : value.trim();

/** Same predicate as pages included in `rowValuesToInput` → mutation `formPages`. */
export const isFormPageIncludedInImportPayload = (
  p: ImportPageValues
): boolean => p.url.trim() !== "";

/** For each index in the submitted `formPages` array, the original `row.formPages` index. */
export const getFormPageFilteredToOriginalIndices = (
  row: FunnelImportRowValues
): number[] => {
  const out: number[] = [];
  row.formPages.forEach((p, originalIdx) => {
    if (isFormPageIncludedInImportPayload(p)) out.push(originalIdx);
  });
  return out;
};

export const pageValuesToInput = (
  page: ImportPageValues,
  options?: { includeHasForm?: boolean }
) => ({
  url: page.url,
  mobileUrl: emptyToNull(page.mobileUrl),
  tabletUrl: emptyToNull(page.tabletUrl),
  queryMatchType: toQueryMatch(page.queryMatchType),
  urlMatchType: toUrlMatch(page.urlMatchType),
  hasForm:
    options?.includeHasForm === true
      ? ((page.landingUrlFormIncluded ? "HAS_FORM" : "NO_FORM") as HasForm)
      : undefined,
  isEnableWhiteout: page.isEnableWhiteout,
  isSpa: page.isSpa,
});

export const rowValuesToInput = (row: FunnelImportRowValues) => {
  if (row.action !== "CREATE" && row.action !== "UPDATE") {
    throw new Error("Funnel import action must be CREATE or UPDATE");
  }
  return {
    action: toImportAction(row.action),
    funnelId: emptyToNull(row.funnelId),
    name: row.name,
    isExperiment: row.isExperiment,
    landingPage: pageValuesToInput(row.landingPage, { includeHasForm: true }),
    formPages: row.formPages
      .filter(isFormPageIncludedInImportPayload)
      .map((p) => pageValuesToInput(p)),
    confirmPage:
      row.confirmPage.url.trim() !== ""
        ? pageValuesToInput(row.confirmPage)
        : null,
    thanksPage: pageValuesToInput(row.thanksPage),
  };
};
